function ApiDocs() {
  return (
    <div>
      <h1>API Documentation</h1>
      <p>There may be API docs here some day but I haven't written them yet.</p>
    </div>
  );
}

export default ApiDocs;
